import { encode } from 'querystring';

import { fechFromBPartsApi } from '../utils';

/**
 * GET /accounts/company/wallet-balance
 *
 * Only companies with a wallet (`staff.has_wallet`) have a balance. The backend
 * answers `403` when the company has no wallet and `204` when the PHC lookup
 * fails — neither is an application error, so both resolve to `null` and the
 * caller simply renders nothing.
 */
export const fetchWalletBalance = async ({
  locale,
}: {
  locale: string;
}): Promise<TWalletBalance | null> => {
  const response = (await fechFromBPartsApi(
    `/${locale}/shop/accounts/company/wallet-balance`,
    {
      credentials: 'include',
    }
  )) as Response;

  if (response.status === 204 || response.status === 403) {
    return null;
  }

  return response.json();
};

/**
 * GET /accounts/company/wallet-movements
 *
 * Paginated wallet movements. Same `403` / `204` semantics as the balance.
 */
export const fetchWalletMovements = async ({
  locale,
  query,
}: {
  locale: string;
  query: {
    page: number;
  };
}): Promise<TWalletMovements | null> => {
  const response = (await fechFromBPartsApi(
    `/${locale}/shop/accounts/company/wallet-movements?${encode(query)}`,
    {
      credentials: 'include',
    }
  )) as Response;

  if (response.status === 204 || response.status === 403) {
    return null;
  }

  return response.json();
};
